import React from 'react';

import { type SxProps } from '@mui/material';
import { type TBlock } from '@wp-block-builder/package';

import getBlockIconComponent from './getBlockIconComponent';

type Props = {
  type: TBlock['type'];
  sx?: SxProps;
};

export default function BlockTypeIcon({ type, sx }: Props): JSX.Element {
  const Component = getBlockIconComponent(type);
  return <Component sx={sx} />;
}
